import {useTranslation} from "react-i18next";
import {Modal} from "@wfp/ui";
import {OrderItem, ServerError} from "../../models/types";
import {OrderItemCard} from "./card";

export interface Props {
    error?: ServerError;
    orderItem: OrderItem;
    onOk?: () => void;
    onCancel: () => void;
}

export const AcceptConfirmation = (props: Props) => {

    const {t} = useTranslation();

    return (
        <div>
            <Modal
                open={true}
                primaryButtonText={t('pickup') as string}
                onRequestSubmit={props.onOk}
                secondaryButtonText={t('cancel') as string}
                onSecondarySubmit={props.onCancel}
                onRequestClose={props.onCancel}
            >
                <OrderItemCard readonly={true} hideState={true} item={props.orderItem}/>
            </Modal>
        </div>
    );
};
